module.exports = __webpack_public_path__ + "./fonts/karnakcondensed-700.ttf";